import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class KAEPriorityDTO  {
    _originalTypeClassName = "zERP.BO.KAEPriorityDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
KAEPriorityDTO.translate = translateService;
}
this.KAECode = null;
this.Priority = null;
this.KAEPriorityDTOKey = null;
this._key = this.KAEPriorityDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
KAECode:any;
Priority:any;
private _KAEPriorityDTOKey:any;
get KAEPriorityDTOKey(): any {
    return this._KAEPriorityDTOKey;
  }
set KAEPriorityDTOKey(value: any) {
    this._KAEPriorityDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.KAEPriorityDTOKey == null || $this.KAEPriorityDTOKey == 0;
            }


}